import React from 'react';
import _ from "lodash";

export default function({maxRate = 5, filled}){ //{must put in props}
    
    const stars = _.range(0, maxRate) //lodash
    //console.log('Stars:', stars);
    const isFraction = (filled+"").includes('.');
    const realNum = (filled+"").split('.')[0];
    //const realNum = fraction[0]; 
    return (
        <div>
            {stars.map( (val, index) => {
                let starIcon = 'star';

                if (index + 1 > filled) {
                    starIcon = 'star_border';
                }
                if(isFraction && index  == realNum){
                    starIcon = 'star_half';
                }
                   return(
                        <i key={index} className="material-icons">{starIcon}</i>
                   ) 
                }
            )}
        </div>
    )
}